import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */

export const getLadingPages = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/landing-pages/?limit=${limit}&offset=${offset}`
  );
  return response.data;
};

export const createLandingPage = async (payload) => {
  const response = await api.post(
    "api/v1/landing-pages/",
    payload
  );
  return response.data;
};

export const updateLandingPage = async (landingPageId, payload) => {
  const response = await api.patch(
    `api/v1/landing-pages/${landingPageId}/`,
    payload
  );
  return response.data;
};

export const deleteLandingPage = async (id) => {
  await api.delete(`api/v1/landing-pages/${id}/`);
};

export const getLandingPageBySlug = async (slug) => {
  const response = await api.get(
    `api/v1/landing/${slug}/`
  );
  return response.data;
};

export const createPreRegistration = async (slug, payload) => {
  const response = await api.post(
    `api/v1/landing/${slug}/register/`,
    payload
  );
  return response.data;
};

export const getSubmissionResponsesById = async (id, limit = 10, offset = 0) => {
  const params = {};
  params.landing_page = id;
  const response = await api.get(
    `api/v1/pre-registrations/?limit=${limit}&offset=${offset}`, { params }
  );
  return response.data;
};

export const exportSubmissionResponsesById = async (id) => {
  const params = {};
  params.landing_page = id;
  const res = await api.get("api/v1/pre-registrations/export/", { params });
  return res.data;
};